export default "__VITE_ASSET__aKU7QZVW__"